import '../../../Common.scss';
import '../../Common.scss';
import './BillingInformation.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingInfo } from 'types/billing';
import { ReactComponent as ChinaUnionPayIcon } from 'images/icons/CreditCardIcons/chinaUnionPay.svg';
import { ReactComponent as DinersClubIcon } from 'images/icons/CreditCardIcons/dinersClub.svg';
import { ReactComponent as DiscoverIcon } from 'images/icons/CreditCardIcons/discover.svg';
import { ReactComponent as InvoiceIcon } from 'images/icons/Invoice.svg';
import { ReactComponent as JCBIcon } from 'images/icons/CreditCardIcons/jcb.svg';
import { ReactComponent as MasterCardIcon } from 'images/icons/CreditCardIcons/mastercard.svg';
import { ReactComponent as PencilIcon } from 'images/icons/Pencil.svg';
import { ReactComponent as VisaIcon } from 'images/icons/CreditCardIcons/visa.svg';
import { ReactComponent as AmericanExpressIcon } from 'images/icons/CreditCardIcons/americanExpress.svg';
import { EditBillingInformation } from '../EditBillingInformation/EditBillingInformation';
import { EditCardDetails } from '../EditCardDetails/EditCardDetails';

export const BillingInformationContent = ({ billingInfo }: { billingInfo: BillingInfo }) => {
  const { t } = useTranslation();
  const [isEditCardModalOn, setIsEditCardModalOn] = useState(false);
  const [isEditAddressModalOn, setIsEditAddressModalOn] = useState(false);

  const { payment_method } = billingInfo;

  return (
    <>
      <div className='profile-section-title'>
        <InvoiceIcon />
        {t('BillingInformation', { ns: 'billingInformation' })}
      </div>
      <div className='billing-info-wrapper'>
        <div className='card-wrapper'>
          <div className='card-type'>
            {payment_method.card_type === 'Diners Club' && <DinersClubIcon />}
            {payment_method.card_type === 'American Express' && <AmericanExpressIcon />}
            {payment_method.card_type === 'Discover' && <DiscoverIcon />}
            {payment_method.card_type === 'JCB' && <JCBIcon />}
            {payment_method.card_type === 'MasterCard' && <MasterCardIcon />}
            {payment_method.card_type === 'Union Pay' && <ChinaUnionPayIcon />}
            {payment_method.card_type === 'Visa' && <VisaIcon />}
            <strong>{payment_method.card_type}</strong>
          </div>
          <div className='card-number'>**** **** **** {payment_method.last_four}</div>
          <div className='card-expiry'>{`${t('Expiry', { ns: 'billingInformation' })} ${
            payment_method.exp_month < 10 ? `0${payment_method.exp_month}` : payment_method.exp_month
          }/${payment_method.exp_year}`}</div>
          <div className='edit-button' onClick={() => setIsEditCardModalOn(true)}>
            <PencilIcon />
          </div>
          <EditCardDetails isOpen={isEditCardModalOn} billingInfo={billingInfo} close={() => setIsEditCardModalOn(false)} />
        </div>
        <div className='billing-address-wrapper'>
          <span>{t('BillingAddress', { ns: 'billingInformation' })}</span>
          {billingInfo.address.street1 && <p>{billingInfo.address.street1}, </p>}
          {billingInfo.address.street2 && <p>{billingInfo.address.street2}, </p>}
          {billingInfo.address.postal_code && (
            <p>
              {billingInfo.address.postal_code} {billingInfo.address.city}, {billingInfo.address.country}
            </p>
          )}
          <div className='edit-button' onClick={() => setIsEditAddressModalOn(true)}>
            {t('EditBillingInformation', { ns: 'billingInformation' })}
          </div>
          <EditBillingInformation isOpen={isEditAddressModalOn} close={() => setIsEditAddressModalOn(false)} />
        </div>
      </div>
    </>
  );
};
